import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {

    kayitData:{
        yetkiliUsername: "",
        yetkiliMail: "",
        yetkiliPhoneNumber: "",
        vergiNo: "",
        firmaName: "",
        password: "",
        passwordAgain: "",
        vehicleVolume: "",
        userDesc: ""
    },

    firmaType:{
        value: "",
        text: ""
      },

    fromCityList: [],

    toCityList:[],

    yetkiliInfo: {
        name: "",
        mail: "",
        phoneNumber: "",
        isMailControlled: false,
        isPhoneNumberControlled: false
    },

    modalType: null,
    modalLocation: null,
    registerResultModalData:null,

    checkInformationText: {
        uyelikSozlesmesi: false,
        aydinlatmaMetni: false,
        acikRizaMetni: false
    },

    isLoadingMailVerification: false,
    isLoadingRegister: false,
    isVerificationTrue:false,

    registerErrorMessage: "",

    registerVerificationStatus: false,

    registerVerificationCodeTimer: 180
}



export const sendMailAdresForVerification = createAsyncThunk("register/sendMailAdresForVerification", async(email, thunkApi)=> {
    try {
        const token = thunkApi.getState().auth.token
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const {data} = await axios.post(`${process.env.REACT_APP_API_URI}/Auth/MailVerificationRegister`, email, config)
        
        if(data?.data?.isVerificationCodeSended){
            thunkApi.dispatch(showRegisterModal("verificationCode"))
            thunkApi.dispatch(setRegisterVerificationStatus(true))
            thunkApi.dispatch(setRegisterVerificationCodeTimer(180))
        }
        if(data?.message){
            thunkApi.dispatch(showRegisterModal("forgotResult"))
            thunkApi.dispatch(setRegisterResultModalData({msg: data?.message || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        }
        
        return data
    } catch (error) {
        thunkApi.dispatch(showRegisterModal("forgotResult"))
        thunkApi.dispatch(setRegisterResultModalData({msg: error.response.data.ErrorDto.Errors[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error"}))
        return thunkApi.rejectWithValue(error)
    }
})


export const register = createAsyncThunk("register/register", async(body, thunkApi)=> {
    try {
        const {data} = await axios.post(`${process.env.REACT_APP_API_URI}/Auth/Register`, body)
        if(data){
            thunkApi.dispatch(showRegisterModal("registerResult"))
        }
        
        return data
    } catch (error) {
        // thunkApi.dispatch(showRegisterModal("forgotResult"))
        thunkApi.dispatch(setRegisterResultModalData({msg: error.response.data.ErrorDto.Errors[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


const registerSlice = createSlice({
    name: "register",
    initialState,
    reducers: {

        setKayitData: (state, action) => {
            state.kayitData = {...state.kayitData, ...action.payload}
        },

        updateFromCityList: (state,action) => {
            state.fromCityList = action.payload
        },

        updateToCityList: (state,action) => {
            state.toCityList = action.payload
        },

        updateFirmaType: (state, action) => {
            state.firmaType = action.payload
        },

        setCheckInformationText: (state, action) => {
            state.checkInformationText = {...state.checkInformationText, ...action.payload}
        },

        showRegisterModal: (state, action) => {
            state.modalType = action.payload;
            state.modalLocation = window.location.pathname
        },

        setRegisterResultModalData: (state, action)=> {
            state.registerResultModalData = action.payload
        },

        setIsVerificationTrue: (state, action) => {
            state.isVerificationTrue = action.payload
        },

        setRegisterVerificationStatus: (state, action) => {
            state.registerVerificationStatus = action.payload
        },

        setRegisterVerificationCodeTimer: (state, action) => {
            state.registerVerificationCodeTimer = action.payload
        }

    },
    extraReducers:(builder)=> {
        builder

        .addCase(sendMailAdresForVerification.pending, (state)=> {
            state.isLoadingMailVerification = true
            state.registerErrorMessage = ""
        })

        .addCase(sendMailAdresForVerification.fulfilled, (state, action)=> {
            state.isLoadingMailVerification = false
            state.registerErrorMessage = action.payload.message
        })

        .addCase(sendMailAdresForVerification.rejected, (state)=> {
            state.isLoadingMailVerification = false
        })

        .addCase(register.pending, (state)=> {
            state.isLoadingRegister = true
        })

        .addCase(register.fulfilled, (state, action)=> {
            state.isLoadingRegister = false
        })

        .addCase(register.rejected, (state)=> {
            state.isLoadingRegister = false
        })
    
    }
})

export const {
    setCheckInformationText,
    showRegisterModal,
    setKayitData,
    updateFromCityList,
    updateToCityList,
    updateFirmaType,
    setRegisterResultModalData,
    setIsVerificationTrue,
    setRegisterVerificationStatus,
    setRegisterVerificationCodeTimer
} = registerSlice.actions
export default registerSlice.reducer